// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-31ddedad] .ag-theme-balham .ag-row-selected {\n  background-color: transparent;\n  background-color: var(--ag-selected-row-background-color, transparent);\n}\n.total-tasks[data-v-31ddedad] {\n  position: absolute;\n  right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
